import getQueryString from './getQueryString';
const getQueryStringFromState = (state) => {
    const { listingSearch: { currentSearchQuery }, } = state;
    return getQueryString(currentSearchQuery);
};
export default getQueryStringFromState;
